import { usePrivilege } from "../../providers/privilegeprovider";
import { useCallback, useEffect, useState, useMemo } from "react";
import FolderGrid from "../../components/FolderGrid";
import SearchBuildingBar from "../../components/SearchBuildingBar";
import { useAuth } from "../../providers/authprovider";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import useInvoiceModal from "./hooks/useInvoiceModal";
import handleResponseCode from "./utils/handleResponseCode";
import InvoicesList from "./InvoicesList";
import InvoicesToIssue from "./InvoicesToIssue";

export default function InvoicesPage(props) {
  const [folders, setFolders] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(false);
  const [error, setError] = useState("");
  const [buildingFilter, setBuildingFilter] = useState(undefined);
  const { createInvoiceModal, CreateInvoiceModal } = useInvoiceModal();
  const { invoices } = useAuth();
  const navigate = useNavigate();
  const { getPrivilege } = usePrivilege();
  const privilege = getPrivilege("invoices");

  const filteredFolders = useMemo(() => {
    if (!buildingFilter) return folders;

    return folders.filter((bf) => bf.buildingId === buildingFilter.id);
  }, [folders, buildingFilter]);

  const loadFolders = useCallback(async () => {
    setLoadingFolders(true);
    setError("");

    // jeśli endpoint ma filtrowanie po budynku - tu dopnij param (jeśli nie, usuń)
    const result = await invoices.fetchInvoiceFolders();

    if (!result?.success) {
      setFolders([]);
      setError(handleResponseCode(result?.status, result?.error));
      setLoadingFolders(false);
      return;
    }

    setFolders(result.content || []);
    setLoadingFolders(false);
  }, [invoices]);

  useEffect(() => {
    loadFolders();
  }, [loadFolders]);

  const handleSetBuildingFilter = (building) => {
    setBuildingFilter(building);
  };

  const handleEdit = () => {
    // Implement edit logic if needed
  };

  const handleSave = (invoice, building) => {
    const building_Id = building?.id;
    if (!building_Id) return;

    const found = folders.find((folder) => folder.buildingId === building_Id);

    if (found) {
      // zwiększ liczbę plików w folderze
      setFolders((oldFolders) =>
        oldFolders.map((folder) =>
          folder.buildingId === building_Id
            ? { ...folder, files: folder.files + 1 }
            : folder,
        ),
      );
    } else {
      // dodaj nowy folder
      setFolders((oldFolders) => [
        ...oldFolders,
        {
          buildingId: building_Id,
          name: building.name,
          files: 1,
        },
      ]);
    }
  };

  const handleInvoiceDeleted = (invoice, building) => {
    console.log("Usunięto fakturę:", invoice);
    const building_Id = building?.id;
    if (!building_Id) return;

    const found = folders.find((folder) => folder.buildingId === building_Id);

    if (found) {
      // zmniejsz liczbę plików w folderze
      setFolders((oldFolders) =>
        oldFolders.map((folder) =>
          folder.buildingId === building_Id
            ? { ...folder, files: folder.files - 1 }
            : folder,
        ),
      );
    }
  };

  const openFolder = (folder) => {
    navigate(`./${folder.buildingId}/`);
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <div className={"container"}>
              <Row>
                <Col className={"p-3"}>
                  <SearchBuildingBar
                    onSelect={handleSetBuildingFilter}
                    defaultValue={buildingFilter}
                  />
                </Col>
                <Col>
                  {privilege.edit && (
                    <>
                      <Button
                        className="btn btn-primary m-3 me-4 float-end"
                        onClick={() => {
                          createInvoiceModal.show({
                            title: "Nowa faktura",
                            initialBuilding: null,
                            initialDescription: "",
                            onSaved: handleSave,
                          });
                        }}
                      >
                        Nowa faktura
                      </Button>
                      <Button
                        className="btn btn-primary m-3 me-4 float-end"
                        onClick={() => navigate("/invoices/to-issue")}
                      >
                        Faktury do wystawienia
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
              <FolderGrid folders={filteredFolders} onSelect={openFolder} />
            </div>
          }
        />
        <Route path="/to-issue" element={<InvoicesToIssue onInvoiceAdded={handleSave} />} />
        <Route
          path="/:buildingId"
          element={
            <InvoicesList buildings={folders} onInvoiceAdded={handleSave} onInvoiceDeleted={handleInvoiceDeleted} />
          }
        />
      </Routes>
      <CreateInvoiceModal />
    </>
  );
}
